module.exports = __webpack_public_path__ + "static/img/7.fb00920.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/logos/7.svg
// module id = 702
// module chunks = 1